export default __webpack_public_path__ + "static/media/img_23.62738137.JPG";